import React from 'react';
import { MdOutlineClose, MdOutlineErrorOutline, MdOutlineCheckCircle } from 'react-icons/md';
import { HiOutlineInformationCircle } from 'react-icons/hi2';

const TYPE_CLASSES = {
    error: {
        accent: 'border-red-500',
        icon: <MdOutlineErrorOutline className='text-red-500 text-3xl' />,
    },
    success: {
        accent: 'border-green-500',
        icon: <MdOutlineCheckCircle className='text-green-500 text-3xl' />,
    },
    warning: {
        accent: 'border-yellow-500',
        icon: <HiOutlineInformationCircle className='text-yellow-500 text-3xl' />,
    },
    info: {
        accent: 'border-blue-500',
        icon: <HiOutlineInformationCircle className='text-blue-500 text-3xl' />,
    },
};

const SiteAnnouncementBanner = ({ announcement, onDismiss }) => {
    const type = TYPE_CLASSES[announcement.type] ? announcement.type : 'info';
    const theme = TYPE_CLASSES[type];

    return (
        <div className={`pointer-events-auto w-full rounded-2xl border bg-white shadow-2xl ${theme.accent} border-l-8`}>
            <div className="flex items-start gap-4 p-4 md:p-4">
                <div className="shrink-0 pt-0.5">
                    {theme.icon}
                </div>
                <div className="min-w-0 flex-1">
                    {announcement.title && <h1 className='text-base font-semibold text-text-secondary-dark'>{announcement.title}</h1>}
                    <p className='mt-1 text-sm leading-6 text-text-secondary-dark whitespace-pre-line'>{announcement.message}</p>
                    {announcement.actionUrl && announcement.actionLabel && (
                        <a
                            href={announcement.actionUrl}
                            className='mt-3 inline-flex text-sm font-medium text-blue-600 underline underline-offset-2'
                            target='_blank'
                            rel='noreferrer'
                        >
                            {announcement.actionLabel}
                        </a>
                    )}
                </div>
                <button onClick={onDismiss} className='rounded-full p-1 transition-colors hover:bg-slate-100'>
                    <MdOutlineClose className='text-2xl text-text-secondary-reg' />
                </button>
            </div>
        </div>
    );
};

export default SiteAnnouncementBanner;
